/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
// import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import Link from '../../components/Link';
import { Grid, Row, Col, Button, Popover, OverlayTrigger, FormGroup, FormControl, ControlLabel, Glyphicon } from 'react-bootstrap';
import s from './ServicesHeader.scss';
import logoInspire from './logo.png';
import Login from '../../routes/login';
import { herby } from './herby';
import { fetchArms } from '../../lib/utils';
import { fetchDistrictArms } from '../../actions/eservices';
import { ListaUrzedow } from '../../routes/urzad/ListaUrzedow';
import { setRuntimeVariable } from '../../actions/runtime';

import history from '../../core/history';

import { adminEndpoint, adminRole } from '../../config';
import { AllServices } from '../../routes/eservices/AllServices';

const loginPopup = (
  <Popover id="popover-positioned-bottom" >
    <form method="post">
      <FormGroup controlId="formValidationNull" validationState={null}>
        <ControlLabel>Login</ControlLabel>
        <FormControl type="text" />
      </FormGroup>
      <FormGroup controlId="formValidationNull" validationState={null}>
        <ControlLabel>Hasło</ControlLabel>
        <FormControl type="password" />
      </FormGroup>
      <Button style={{ width: '100%' }} bsStyle="primary" type="submit">
          Zaloguj
      </Button>
    </form>
  </Popover>
);

class ServicesHeader extends React.Component {
  state = {
    // herb: null,
    redirectURL: '/',
    ariaExpanded: false,
    showMobileMenu: false,
    prefix: null,
  }
  redirectURL = '/'

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const keys = Object.keys(this.props.districts);
    const prefix = keys[0];
    if (prefix !== undefined) {
      this.setState({ prefix }, () => this.props.fetchDistrictArms(prefix));
    }
    if (this.props.user && !this.props.user.loginConfirmed && !window.location.href.includes('/panel/')){
      window.location.href = `/panel/${this.props.user.username}`;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.prefix !== undefined && nextProps.prefix !== this.state.prefix) {
      this.props.fetchDistrictArms(nextProps.prefix);
      // fetchArms(nextProps.prefix).then(resp => {
      //   this.setState({ herb: resp });
      // });
    }
  }
  viewMobileMenu = () => {
    this.setState({ showMobileMenu: !this.state.showMobileMenu });
  }

  nazwaUrzedow = () => {
    let gmina;
    for (const key in this.props.districts) {
      if (this.props.districts[key].prefix === this.state.prefix){
        gmina = this.props.districts[key].placeOfSettling;
      }
    }
    return gmina;
  }

  increaseFontSize = e => {
    e.preventDefault();
    this.props.setRuntimeVariable({ name: 'fontSize', value: this.props.fontSize + 0.2 });
  };
  resetFontSize = e => {
    e.preventDefault();
    this.props.setRuntimeVariable({ name: 'fontSize', value: 1.4 });
  };
  decreaseFontSize = e => {
    e.preventDefault();
    this.props.setRuntimeVariable({ name: 'fontSize', value: this.props.fontSize - 0.2 });
  };

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12} className="no-padding" style={this.props.colors}>
            <header className={`eus-bckgr`}>
              {this.state.prefix ?
              <div className="col-sm-12 col-md-4 eus-logo">
                {this.props.arms ? <img className="herb-gmina" src={`https://e-spdp.pl/oldihub/upload/herby/${this.props.arms}`} alt="herb gminy" /> : null}
                <h3 className="title-gmina" style={{ marginTop: '20px', fontSize: 'small', textAlign: 'center' }}>{this.state.prefix ? this.nazwaUrzedow() : null}</h3>
              </div>
              :
              null}
              <div className="mobile-btn hidden-sm hidden-md hidden-lg hidden-xl col-xs-12 perfect-center" onClick={this.viewMobileMenu}><Glyphicon glyph="menu-hamburger" /></div>
              <div className={`navbar zeroH mobile-top-nav ${!this.state.showMobileMenu ? '' : 'show-mobile'}`} style={{ marginBottom: '0' }}>
                <div className="col-xs-12 col-sm-3 navbar-collapse menu-glowne">
                  <ul className="nav navbar-nav">
                    <li><a href="/euslugi" className={this.props.active === "main" ? "active" : ""} style={this.props.colors}>Strona Główna</a></li>
                    {/* <li><a href="/euslugi" className={this.props.active === "catalogue" ? "active" : ""}  style={this.props.colors}>Katalog E-USŁUG</a></li> */}
                    {/* <li><a href="/urzad" className={this.props.active === "district" ? "active" : ""}  style={this.props.colors}>Urzędy</a></li> */}
                    {this.state.prefix === 'gmina_cieszanow' ?
                    <li><a href="/gmina_cieszanow" style={this.props.colors}>Mapa</a></li>
                    : null }
                    {this.state.prefix === 'gmina_grodzisko_dolne' ?
                    <li><a href="http://mapa.inspire-hub.pl/#/gmina_grodzisko_dolne" style={this.props.colors}>Mapa</a></li>
                    : null }
                    {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(adminRole) >= 0 ?
                      <li className="dropdown" onMouseEnter={() => this.setState({ ariaExpanded: true })} onMouseLeave={() => this.setState({ ariaExpanded: false })}>
                        <a href="#" className="dropdown-toggle">Admin
                          <span className="caret"></span></a>
                        <ul className="dropdown-menu" style={{display: this.state.ariaExpanded ? 'block': 'none'}}>
                          <li><a href={`${adminEndpoint}/districts`}>Gminy</a></li>
                          <li><a href={`${adminEndpoint}/users`}>Użytkownicy</a></li>
                          <li><a href={`${adminEndpoint}/claims`}>Dokumenty</a></li>
                          <li role="separator" className="divider"></li>
                          <li><a href={`${adminEndpoint}/available_services`}>Dostępne eusługi</a></li>
                          <li role="separator" className="divider"></li>
                          <li><a href={`${adminEndpoint}/update_emuia`}>Aktualizacja EMUIA</a></li>
                        </ul>
                      </li>
                    : null
                    }
                    {this.props.user ?
                      <li><a href="/verifyDocument" style={this.props.colors}>Weryfikator dokumentów cyfrowych</a></li> : null
                    }
                  </ul>
                </div>

                <div className="eus-resize">
                  <div onClick={this.increaseFontSize}>
                    <strong>A+&nbsp;</strong>
                  </div>
                  <div onClick={this.resetFontSize}>
                    <strong>A&nbsp;&nbsp;</strong>
                  </div>
                  <div onClick={this.decreaseFontSize}>
                    <strong>A-&nbsp;</strong>
                  </div>
                  <div
                    onClick={() => { this.props.setColors('normal'); }}
                    style={{ marginLeft: '5px', border: '3px solid grey' }}
                    className="glyphicon glyphicon-text-background"
                  />
                  <div
                    onClick={() => { this.props.setColors('intenseBlack'); }}
                    style={{ marginLeft: '5px', color: 'black', background: 'white', border: '3px solid grey' }}
                    className="glyphicon glyphicon-text-background"
                  />
                  <div
                    onClick={() => { this.props.setColors('intenseBlackYellow'); }}
                    style={{ marginLeft: '5px', color: 'black', background: 'yellow', border: '3px solid grey' }}
                    className="glyphicon glyphicon-text-background"
                  />
                  <div
                    onClick={() => { this.props.setColors('intenseYellowBlack'); }}
                    style={{ marginLeft: '5px', color: 'yellow', background: 'black', border: '3px solid grey' }}
                    className="glyphicon glyphicon-text-background"
                  />
                </div>
                <div className="col-xs-12 col-sm-3 navbar-collapse logowanie">
                  {this.props.user ? (
                    <ul className="nav navbar-nav">

                      {!this.props.user.isConnectedToPZ && !this.props.user.isWkProfile ?
                        <li><a href="/connectPZ" style={this.props.colors}>Połącz z PZ</a></li> : null }
                      <li><a href={`/panel/${this.props.user.username}/mojedokumenty`} style={this.props.colors}>{this.props.user.username}</a></li>
                      <li><a href="/logout" style={this.props.colors}>Wyloguj</a></li>
                    </ul>
                  ) : (
                    <ul className="nav navbar-nav">
                      {/* <li><a href="/rejestracja" style={this.props.colors}>Zarejestruj</a></li> 
                      <li>
                        <a href={process.env.LOGIN_ENDPOINT} style={this.props.colors}>Zaloguj</a>
                      </li>*/}
                    </ul>
                  )}
                </div>
              </div>
            </header>
          </Col>
        </Row>
        {/* <Row>
        { this.state.prefix == 'olsztyn' &&
          <div>
            <p style={{ textAlign: 'center', backgroundColor: 'red' }}><b>Uwaga! Trwają pracę konfiguracyjne portalu e-usług, już niedługo będziesz mógł zamówić materiały WODGiK bez wychodzenia z domu!</b></p>
          </div>
        }
        </Row> */}
      </Grid>
    );
  }
}
const mapState = (state) => ({
  user: state.user,
  arms: state.eservices.arms,
  districts: state.district.districts,
  eservices: state.district.eservices,
  fontSize: state.runtime.fontSize,
  isAllDistrictFetched: state.district.isAllDistrictFetched,
  isServicesFetched: state.district.isServicesFetched
});
const mapDispatch = {
  setRuntimeVariable,
  fetchDistrictArms,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ServicesHeader));



// WEBPACK FOOTER //
// src/components/ServicesHeader/ServicesHeader.js